export enum ESubContractingLab {
    EULHCF = 1,
    EULESA = 2,
    EUFRNA8 = 3,
    EUFRBO7 = 4,
    EUFRVE5 = 5,
    EUFRSG2 = 6,
    EUFRHB2 = 7,
    EUFRCB = 8,
    EUFR17 = 9,
    Externe = 10,
    EUFR266 = 11,
    EUFR267 = 12,
}